<rt-empty-state
  [icon]="'error-outline'"
  [title]="i18n.title | translate"
  [hasContentMargin]="false"
  variant="small"
  layout-full-width
  padding
>
  <div layout-inline margin-bottom-medium>
    {{ i18n.message | translate }}&nbsp;
    @if (supportEnabled()) {
      <a (click)="supportClick.emit()">{{ i18n.support ?? '' | translate }}</a>
    }
  </div>

  @if (downloadEnabled()) {
    <rt-button (click)="downloadClick.emit()">
      <rt-icon name="file-download" />
      <span>{{ i18n.download ?? '' | translate }}</span>
    </rt-button>
  }
</rt-empty-state>
